import {Component} from '@angular/core';
import {FeedbackModeService} from '@twpub/core/services/feedback-mode.service';
import {MatIcon} from '@angular/material/icon';
import {MatTooltip} from '@angular/material/tooltip';

@Component({
  selector: 'pub-feedback-mode-overlay',
  templateUrl: './feedback-mode-overlay.component.html',
  styleUrls: ['./feedback-mode-overlay.component.scss'],
  standalone: true,
  imports: [MatIcon, MatTooltip]
})
export class FeedbackModeOverlayComponent {
  constructor(public feedbackMode: FeedbackModeService) {
  }

  sendGeneralFeedback(event: Event): void {
    event.preventDefault();
    this.feedbackMode.openGeneralFeedback();
  }

  cancelFeedbackMode(): void {
    this.feedbackMode.deactivate();
  }
}
